import React, { FC } from 'react'

//* utils
import { LocaleCodes } from '../../../../constants/localization.constants'
import { ComponentAnnouncement } from '../../../../models/components/announcement'
import { MenuGroup } from '../../../../models/others/menuGroup'

//* components
import Layout from '../../../layouts/layout'
import { AnalystPageContent } from './subcomponent'

type Props = {
  pageContext: any
  path: string
  headerData?:
    | {
        allContentfulNavMenu: {
          nodes: MenuGroup[]
        }
      }
    | undefined
  footerData?:
    | {
        allContentfulNavMenu: {
          nodes: MenuGroup[]
        }
      }
    | undefined
  announcementData?: ComponentAnnouncement
  browserLanguageData?: any
}

const AnalystReportPage: FC<Props> = ({
  pageContext,
  path,
  headerData,
  footerData,
  announcementData,
  browserLanguageData,
}) => {
  const pageData = pageContext.analystReportData || null
  if (!pageData) return null

  const defaultLocale = pageContext.pageLocale || LocaleCodes.ENGLISH.code
  const hasForm = pageData.useCase === 'No Form' ? false : true

  const analystReportData = {
    number: pageData.resourceCategory?.number || 0,
    hasForm,
    microcopy: pageData.microcopy?.values || [],
    downloadAsset: pageData.downloadAsset?.products?.[0] || null,
    formIntro: pageData.formIntro || null,
    formOverride: pageData.formOverride || null,
    mainImage: {
      url: pageData.mainImage?.image?.file?.url || '/',
      alt: pageData.mainImage?.altText || '',
    },
    hero: {
      h1Title: pageData.h1Title || '',
      blueFilter: pageData.blueFilter,
      heroBullets: pageData.heroBullets,
      heroSubtitle: pageData.heroSubtitle,
      heroTextCentered: !hasForm ? false : pageData.heroTextCentered,
      heroFontBlack: pageData.heroFontBlack,
      heroEyebrow: pageData.heroEyebrow,
    },
    formAlignToBody: pageData.formAlignToBody,
    thankYouPage: pageData.thankYouPage,
    marketoJsScript: pageData.marketoJsScript?.marketoJsScript || '',
    seoMetadata: pageData.seoMetadata || null,
    slug: pageData.slug || '/',
    body: pageData.body || '',
    finePrint: pageData.finePrint || '',
    cnFormOverride: pageData.cnFormOverride || null,
  }

  return (
    <Layout.Template
      lang={defaultLocale}
      minimalHeader={true}
      minimalFooter={true}
      headerData={headerData}
      footerData={footerData}
      announcementData={announcementData}
      browserLanguageData={browserLanguageData}
      pageType="analystReport"
      slug={pageContext.analystReportData?.slug || ''}
      availableLocales={pageContext.availableLocales}>
      <div data-cy="AnalystReport">
        <AnalystPageContent
          data={analystReportData}
          marketoFormData={pageData.formOverride || pageContext.marketoFormData}
          locale={defaultLocale}
          availableLocales={pageContext.availableLocales}
          path={path}
        />
      </div>
    </Layout.Template>
  )
}

export default AnalystReportPage
